import CartModalController from 'emun.cart/cart-modal.controller.es6'

class PaymentMethodPickerController extends CartModalController {
    constructor($session, $cart, $uibModalInstance, options) {
        'ngInject';
        super($session, $cart, $uibModalInstance, options); // TODO: options?
    }

    select(paymentMethod) {
        let $ctrl = this;
        $ctrl.picker.selecting.notify(paymentMethod);
        if(!paymentMethod.companyName) paymentMethod.companyName = paymentMethod.name;
        return $ctrl.$cart.applyPaymentMethod(paymentMethod).then(res => {
            $ctrl.$close(res);
            $ctrl.picker.selected.notify(res);
        });
    }
    submit(paymentMethod) {
        let $ctrl = this;
        $ctrl.select(paymentMethod);
    }
    create() {
        let $ctrl = this;
        $ctrl.picker.creating.notify($ctrl);
        $ctrl.$dismiss({ reason: 'create' });
    }
    edit(paymentMethod) {
        let $ctrl = this;
        $ctrl.picker.editing.notify(paymentMethod);
        $ctrl.$dismiss({ reason: 'edit', paymentMethod });
    }
    delete(paymentMethod) {
        let $ctrl = this;
        $ctrl.picker.deleting.notify(paymentMethod);
        return $ctrl.$cart.deletePaymentMethod(paymentMethod).then(res => {
            $ctrl.query.load(true);
            $ctrl.picker.deleted.notify(res);
        });
    }
}

function PaymentMethodPickerFactory($cart, $q, modals, AutoQueryLegacy) {
    'ngInject';
    class PaymentMethodPicker extends AutoQueryLegacy {
        constructor(options) {
            if(!options) options = {};
            let b2c = $cart.businessModel === 'Retail';
            let purchaserType = b2c ? 'Consumer' : 'Retailer';
            let url = `QueryPaymentMethods/${$cart.businessModel}/${$cart.purchaser.id || 0}.json?JsConfig=ExcludeDefaultValues&Fields=${options.fields || options.selectFields || '*'}`;
            let aqOptions = angular.extend({ url, autoLoad: false, append: false, take: 100 }, options);
            super(aqOptions);
            let picker = this;
            ['editing', 'creating', 'selecting', 'selected', 'deleting', 'deleted'].forEach(k => {
                picker[k] = $q.defer();
                picker[k].on = picker[k].subscribe = picker[k].sub = cb => picker[k].promise.finally(null, cb);
            });
            picker.loaded.subscribe(() => {
                if (b2c) picker.results.forEach(r => r.personName = {full:r.name});
                else picker.results.forEach(r => !r.id && r.token && (r.id = r.token));
            })
        }
        open(current) {
            let picker = this;
            if (!current) current = $cart.paymentMethod;
            let modalInstance = picker.modal = modals.open({
                size: 'lg',
                templateUrl: 'payment-method-picker.html',
                controller: PaymentMethodPickerController,
                bindToController: true,
                controllerAs: '$ctrl',
                resolve: {
                    options: () => { return { current, picker, query: picker } }
                }
            });

            return modalInstance.result;
        }
    }
    return PaymentMethodPicker;
}

function PaymentMethodPickerDirectiveFactory(PaymentMethodPicker, $parse) {
    return {
        scope: false,
        link: function (scope, element, attr) {
            let picker = new PaymentMethodPicker(scope.$eval(attr.autoQueryOptions));
            let fieldName = attr.ngModel || attr.paymentMethodPicker || attr.paymentMethodPicker || 'paymentMethodPicker';
            picker.linkDirective(scope, attr);
            fieldName && $parse(fieldName).assign(scope, picker);

            var $targets = (attr.clickSelector ? element.find(attr.clickSelector) : element);
            $targets.on('click', e => picker.open(scope.$eval(attr.current)));
        }
    }
}

angular.module('emun.cart')
    .factory('PaymentMethodPicker', PaymentMethodPickerFactory)
    .directive('paymentMethodPicker', PaymentMethodPickerDirectiveFactory);